export const SET_CATEGORY = "SET_CATEGORY";
export const GET_CATEGORY = "GET_CATEGORY";
